<footer class="px-4 py-4 md:px-6 text-cp-primary-100 border-t border-cp-primary-20">
  <div
    class="mx-auto flex max-w-5xl flex-col items-start gap-4 lg:flex-row lg:items-center lg:justify-between lg:gap-0"
  >
    <div class="flex flex-col gap-3 text-base lg:flex-row lg:items-center lg:gap-6 lg:text-sm">
      <span>&copy; MLP Finanzberatung SE, {{ currentYear }}</span>
      <a
        href="https://mlp.de/mlp/datenschutz/"
        target="_blank"
        rel="noopener"
        class="cursor-pointer font-normal underline"
        >Datenschutzinformation</a
      >
      <a
        href="https://mlp.de/mlp/impressum/"
        target="_blank"
        rel="noopener"
        class="cursor-pointer font-normal underline"
        >Impressum</a
      >
      <a
        href="https://mlp.de/mlp/rechtliche-hinweise/"
        target="_blank"
        rel="noopener"
        class="cursor-pointer font-normal underline"
        >Rechtliche Hinweise</a
      >
      <!-- TODO(KFZ-2529): point to the cpit Bedingungswerke page once it exists -->
      <a
        href="https://mlpkfz.zeitsprung-makler.de/tarifrechner/bedingungswerke-download/trixi/kfz"
        target="_blank"
        rel="noopener"
        class="cursor-pointer font-normal underline"
        >Bedingungswerke</a
      >
    </div>
    <button
      mat-flat-button
      type="button"
      class="btn-square !bg-cp-secondary-100 !text-white !px-6 !py-3 !text-base !font-bold !leading-6 whitespace-nowrap flex-shrink-0"
      (click)="openWiderruf()"
    >
      Vertrag widerrufen
    </button>
  </div>
</footer>
